import React, { useCallback, useContext, useState } from "react"
import { Space, Switch } from "antd"
import { useTranslation } from "react-i18next"
import { ThemeActions, ThemeContext } from "../../../../contexts/ThemeContex"
import { effectiveTheme, setThemeMode } from "../../../../theme/theme"
import FontPicker from "font-picker-react"
import "./Modes.less"

function Modes() {
  const { t } = useTranslation()
  const { themeDispatch, themeState } = useContext(ThemeContext)
  // Egasi (2026-08-31): Settings'dagi ESKI dark-mode tugmasi ishlamasdi —
  // endi haqiqiy invert-dark tizimiga ulandi (headerdagi tugma bilan bir xil holat)
  const [darkOn, setDarkOn] = useState(effectiveTheme() === "dark")

  const changeFont = useCallback(
    (e) => {
      themeDispatch({
        type: ThemeActions.ChangeFont,
        payload: {
          currentFont: e,
        },
      })
    },
    [themeDispatch]
  )
  const changeTheme = useCallback(
    (e) => {
      // Yagona dark: theme.ts (Telegram palitrasi). Eski ThemeContext'ga
      // 'dark' YUBORILMAYDI — u legacy '.dark' klassi bilan ranglarni buzardi.
      setThemeMode(e ? "dark" : "light")
      setDarkOn(e)
      themeDispatch({
        type: ThemeActions.ChangeTheme,
        payload: {
          currentTheme: "default",
        },
      })
    },
    [themeDispatch]
  )

  return (
    <Space size={10}>
      <Switch
        onChange={(e) => changeTheme(e)}
        checked={darkOn}
        className="theme-switcher"
        checkedChildren={"🌙 " + t("nightTheme")}
        unCheckedChildren={"☀️ " + t("dayTheme")}
      />
      <FontPicker
        apiKey="AIzaSyDPtqHOkdnMVZb6wrHcyz1Mwyn0Au-HCbI"
        activeFontFamily={themeState.currentFont}
        onChange={(nextFont) => changeFont(nextFont.family)}
      />
    </Space>
  )
}

export default Modes
